/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_ActiveInputs */

const en_delivery_board_active = /** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const es_delivery_board_active = /** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

const fr_delivery_board_active = /** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif`)
};

const de_delivery_board_active = /** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const id_delivery_board_active = /** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

/** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */
const ja_delivery_board_active = en_delivery_board_active;

/** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */
const zh_delivery_board_active = en_delivery_board_active;

/** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */
const ar_delivery_board_active = en_delivery_board_active;

/** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */
const it_delivery_board_active = en_delivery_board_active;

/** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */
const ru_delivery_board_active = en_delivery_board_active;

/** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */
const pt_delivery_board_active = en_delivery_board_active;

/** @type {(inputs: Delivery_Board_ActiveInputs) => LocalizedString} */
const ko_delivery_board_active = en_delivery_board_active;

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Delivery_Board_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_active = /** @type {((inputs?: Delivery_Board_ActiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_ActiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_active(inputs)
	if (locale === "es") return es_delivery_board_active(inputs)
	if (locale === "fr") return fr_delivery_board_active(inputs)
	if (locale === "de") return de_delivery_board_active(inputs)
	if (locale === "ja") return ja_delivery_board_active(inputs)
	if (locale === "zh") return zh_delivery_board_active(inputs)
	if (locale === "ar") return ar_delivery_board_active(inputs)
	if (locale === "id") return id_delivery_board_active(inputs)
	if (locale === "it") return it_delivery_board_active(inputs)
	if (locale === "ru") return ru_delivery_board_active(inputs)
	if (locale === "pt") return pt_delivery_board_active(inputs)
	return ko_delivery_board_active(inputs)
});